if (!customElements.get('sz-spin360')) {
  customElements.define('sz-spin360', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.urls = JSON.parse(this.querySelector('[data-frames]').textContent);
      this.image = this.querySelector('.sz-spin360-image');
      this.range = this.querySelector('input');
      this.status = this.querySelector('[role="status"]');
      this.frame = 0;
      this.cache = [];
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, { threshold:0.2 });
      this.observer.observe(this);
      for (const type of ['pointerdown','pointermove','pointerup','pointercancel','touchstart','touchmove','touchend']) {
        this.addEventListener(type, e => e.stopPropagation(), { passive:true });
      }
      this.range.addEventListener('pointerdown', e => {
        if (!this.loaded || e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        this.rangeDrag = e.pointerId;
        this.range.focus({ preventScroll:true });
        this.range.setPointerCapture(e.pointerId);
        this.scrub(e.clientX);
      });
      this.range.addEventListener('pointermove', e => {
        if (this.rangeDrag !== e.pointerId) return;
        e.preventDefault();
        e.stopPropagation();
        this.scrub(e.clientX);
      });
      for (const type of ['pointerup','pointercancel','lostpointercapture']) {
        this.range.addEventListener(type, () => { this.rangeDrag = null; });
      }
      this.range.addEventListener('input', () => this.show(Number(this.range.value)));
      this.image.addEventListener('pointerdown', e => {
        if (!this.loaded || e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        this.drag = { id:e.pointerId, x:e.clientX, frame:this.frame };
        this.image.setPointerCapture(e.pointerId);
      });
      this.image.addEventListener('pointermove', e => {
        if (!this.drag || this.drag.id !== e.pointerId) return;
        e.preventDefault();
        e.stopPropagation();
        const step = Math.max(8, this.image.clientWidth / this.urls.length);
        this.show(this.drag.frame + Math.round((e.clientX - this.drag.x) / step));
      });
      for (const type of ['pointerup','pointercancel','lostpointercapture']) {
        this.image.addEventListener(type, () => { this.drag = null; });
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.initialized = false;
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.status.textContent = '';
      try {
        this.cache = await Promise.all(this.urls.map(src => new Promise((resolve,reject) => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = src;
        })));
        this.loaded = true;
        this.range.max = this.urls.length - 1;
        this.range.disabled = false;
        this.status.textContent = '';
      } catch {
        this.status.textContent = this.status.dataset.error;
      } finally {
        this.loading = false;
      }
    }
    scrub(clientX) {
      const rect = this.range.getBoundingClientRect();
      const inset = 14;
      const width = Math.max(1, rect.width - inset * 2);
      const ratio = Math.min(1, Math.max(0, (clientX - rect.left - inset) / width));
      this.show(Math.round(ratio * (this.urls.length - 1)));
    }
    show(n) {
      if (!this.loaded) return;
      this.frame = ((n % this.urls.length) + this.urls.length) % this.urls.length;
      this.image.removeAttribute('srcset');
      this.image.src = this.cache[this.frame].src;
      this.range.value = this.frame;
    }
  });
}